import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-[#0f0a1a] text-gray-300">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-pink-400 hover:text-pink-300 mb-8" data-testid="cookie-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <h1 className="text-3xl font-bold text-white mb-2">Cookie Policy</h1>
        <p className="text-gray-500 text-sm mb-8">Last updated: January 1, 2025</p>

        <div className="space-y-6 leading-relaxed text-sm">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. What Are Cookies</h2>
            <p>Cookies are small text files stored on your device when you visit a website. They help the website remember your preferences and improve your browsing experience.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. How We Use Cookies</h2>
            <p>We use cookies for the following purposes:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li><strong className="text-gray-200">Essential Cookies:</strong> Required for the website to function properly, including authentication and session management.</li>
              <li><strong className="text-gray-200">Preference Cookies:</strong> Remember your language selection and display preferences.</li>
              <li><strong className="text-gray-200">Analytics Cookies:</strong> Help us understand how visitors interact with our website to improve our services.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Third-Party Cookies</h2>
            <p>Some cookies are placed by third-party services we use:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>Google (authentication via Google OAuth)</li>
              <li>Stripe (payment processing)</li>
              <li>Analytics providers (website usage statistics)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Managing Cookies</h2>
            <p>You can control and delete cookies through your browser settings. Please note that disabling essential cookies may affect the functionality of the website, including login and payment features.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Contact</h2>
            <p>For questions about our use of cookies, contact us via WhatsApp at <a href="https://wa.me/963988242654" className="text-green-400 hover:text-green-300">+963 988 242 654</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
